// extracted by mini-css-extract-plugin
export var faq__pageTitle = "faq-module--faq__pageTitle--pMKma";
export var faq__content = "faq-module--faq__content--LMwYw";
export var faq__details_content = "faq-module--faq__details_content--2YIah";
export var fadeIn = "faq-module--fadeIn--_PDKT";
export var faq__btnset = "faq-module--faq__btnset--1QwEh";
export var faq__btn = "faq-module--faq__btn--1IfF_";